import { useContext } from "react";
import { GoogleMapsLibraryContext } from "../providers/GoogleMapsLibraryProvider";

const useGoogleMapsLibrary = () => {
    const googleMapsLibraryContext = useContext(GoogleMapsLibraryContext);
    if (!googleMapsLibraryContext) {
        throw new Error('GoogleMapsLibraryContext has to be used within <GoogleMapsLibraryContext.Provider>');
    } else {
        return googleMapsLibraryContext
    }
}

export default useGoogleMapsLibrary;